import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReplaceSemicolonPipe } from 'src/app/pipes/replace-semicolon.pipe';
import { shortDescriptionPipe } from './short-description.pipe';
import { ReplaceSemicolonPesosGirsacPipe } from './replace-semicolon-girsac.pipe';
import { ReplaceSemicolonPesosPipe } from './replace-semicolon-pesos.pipe';
import { FormatoNumerosPipe } from './formato-numeros.pipe';


@NgModule({
    declarations: [
        ReplaceSemicolonPipe,
        shortDescriptionPipe,
        ReplaceSemicolonPesosGirsacPipe,
        ReplaceSemicolonPesosPipe,
        FormatoNumerosPipe
    ],
    imports: [ CommonModule ],
    exports: [
        ReplaceSemicolonPipe,
        shortDescriptionPipe,
        ReplaceSemicolonPesosGirsacPipe,
        ReplaceSemicolonPesosPipe,
        FormatoNumerosPipe
    ],
    providers: [],
})
export class PipeModule {}